export const quizData = [
  {
    id: "q1",
    text: "How much weight are you hoping to lose?",
    type: "radio",
    options: [
      { label: "Under 10 lbs", value: "Under 10 lbs" },
      { label: "10-25 lbs", value: "10-25 lbs" },
      { label: "25-50 lbs", value: "25-50 lbs" },
      { label: "50+ lbs", value: "50+ lbs" },
    ],
    testimonial: "I've lost 32 pounds in 4 months without starving myself. The medication works and InjectCo made the process easy and supportive",
    author: "Chelsea R., 46",
    image: "q1.webp",
    singleColumn: false,
  },
  {
    id: "q2",
    text: "How quickly are you hoping to lose it?",
    type: "radio",
    options: [
      { label: "Slow and steady", value: "slow and steady" },
      { label: "Moderate pace", value: "moderate pace" },
      { label: "As fast as safely possible", value: "fast" },
    ],
    testimonial: "Science-backed, doctor-delivered, and results you'll feel in weeks. Your transformation starts now",
    author: "with InjectCo.",
    image: "q2.webp",
    singleColumn: true,
  },
  {
    id: "q3",
    text: "What's your monthly budget?",
    type: "radio",
    options: [
      { label: "Under $200", value: "Under $200" },
      { label: "$200-$400", value: "$200-$400" },
      { label: "$400+", value: "$400+" },
    ],
    testimonial: '"Life changing" is the only way to describe this medication. My whole world has changed and I am a much better version of myself',
    author: "Jen",
    image: "q3.webp",
    singleColumn: true,
  },
  {
    id: "q4",
    text: "Are you okay with weekly injections?",
    type: "radio",
    options: [
      { label: "Yes, no problem", value: "Yes" },
      { label: "I'd prefer a daily shot", value: "I'd prefer a daily shot" },
      { label: "I prefer no injections", value: "No" },
    ],
    testimonial: "<strong>Medications ship within 24 hours</strong>-becuase life's too short to wait for results.",
    image: "q4.webp",
    singleColumn: true,
  },
  {
    id: "q5",
    text: "Do you have type 2 diabetes or PCOS?",
    type: "radio",
    options: [
      { label: "Yes", value: "Yes" },
      { label: "No", value: "No" },
      { label: "Not sure", value: "Not sure" },
    ],
    testimonial: "I took the quiz on a Tuesday and had my meds by Friday, I've already dropped two pant sizes. No clinic visits, no delays just results.",
    author: "Mike D., 52",
    image: "q5.webp",
    singleColumn: true,
  },
  {
    id: "q6",
    text: "Why are you motivated to lose weight?",
    type: "radio",
    options: [
      { label: "I want to feel more confident", value: "I want to feel more confident" },
      { label: "I have a medical reason", value: "I have a medical reason" },
      { label: "I'm preparing for a big event", value: "I'm preparing for a big event" },
      { label: "I just want to look and feel better", value: "I just want to look and feel better" },
    ],
    testimonial: "Join thousands who've taken control of their weight with <strong>InjectCo -real doctors, real meds, real results.</strong>",
    image: "q6.webp",
    singleColumn: true,
  },
  {
    id: "q7",
    text: "What's your age range?",
    type: "radio",
    options: [
      { label: "18-29", value: "18-29" },
      { label: "30-44", value: "30-44" },
      { label: "45-60", value: "45-60" },
      { label: "60+", value: "60+" },
    ],
    testimonial: "InjectCo took care of everything. They explained the meds, answered my questions, and got me started fast",
    author: "Isabella T., 62",
    image: "q7.webp",
    singleColumn: false,
  },
  {
    id: "q8",
    text: "How often do you exercise?",
    type: "radio",
    options: [
      { label: "Rarely or never", value: "Rarely or never" },
      { label: "1-2 times per week", value: "1-2 times per week" },
      { label: "3-5 times per week", value: "3-5 times per week" },
      { label: "Almost daily", value: "Almost daily" },
    ],
    testimonial: "GLP-1 medications like <strong>semaglutide and tirzepatide</strong> help your body regulate hunger hormones, so you feel full faster and stay full longer",
    image: "q8.webp",
    singleColumn: false,
  },
  {
    id: "q9",
    text: "What's your diet currently like?",
    type: "radio",
    options: [
      { label: "I eat mostly healthy foods", value: "I eat mostly healthy foods" },
      { label: "I eat a mix of healthy and processed foods", value: "I eat a mix of healthy and processed foods" },
      { label: "I struggle with portion control and snacking", value: "I struggle with portion control and snacking" },
      { label: "I follow a specific diet (keto, vegetarian, etc.)", value: "I follow a specific diet (keto, vegetarian, etc.)" },
    ],
    testimonial: "I was skeptical, but InjectCo made it feel safe, professional, and Incredibly quick. It's not a gimmick-this is real science that works.",
    author: "Andre W., 55",
    image: "q9.webp",
    singleColumn: true,
  },
  {
    id: "q10",
    text: "Do you currently take any prescription medications?",
    type: "radio",
    options: [
      { label: "Yes, for weight-related conditions", value: "Yes, for weight-related conditions" },
      { label: "Yes, for unrelated conditions", value: "Yes, for unrelated conditions" },
      { label: "No medications", value: "No medications" },
      { label: "I'd rather not say", value: "I'd rather not say" },
    ],
    testimonial: "These medications have shown <strong>15-22% average body weight loss</strong> in clinical studies-significantly more than most weight loss plans.",
    image: "q10.webp",
    singleColumn: true,
  },
  {
    id: "q11",
    text: "How committed are you to losing weight right now?",
    type: "radio",
    options: [
      { label: "I'm just exploring", value: "just exploring" },
      { label: "I want to start soon", value: "wanting to start soon" },
      { label: "I'm ready to begin right away", value: "ready to begin right away" },
    ],
    testimonial: "This changed everything. No more constant cravings. I feel in control again-and I owe that to InjectCo",
    author: "Latoya B., 46",
    image: "q11.webp",
    singleColumn: true,
  },
  {
    id: "q12",
    text: "What's your biggest challenge with losing weight?",
    type: "radio",
    options: [
      { label: "Staying consistent", value: "staying consistent" },
      { label: "Managing cravings", value: "managing cravings" },
      { label: "Lack of time", value: "lack of time" },
      { label: "Medical reasons", value: "medical reasons" },
      { label: "I'm not sure", value: "unknown" },
    ],
    testimonial: "They also offer <strong>metabolic and cardiovascular benefits</strong>, including better blood sugar control, improved insulin sensitivity, and more energy.",
    image: "q12.webp",
    singleColumn: false,
  },
];
